$(()=>{
   // $('.product-btn-disable .my-product-form__submit').addClass('disable').prop( 'disabled', true );
   $('select[name="options[Inclusions]"]').val('one inclusion');
   if($('variant-selects').length > 0){
      $('variant-selects')[0].onVariantChange();
   }
  
    let arr=[];
    const obj = {
    'inclusions':'',
    'texture':'',
    'optional':'',
    'design':'',
    'ashes':'',
    'other':'',
    'engraved':'',
    'engraved_item': false,
    }
    function nullElement(){
        $('.select__wrap').each(function(){
            $(this).removeClass('active');
            $(this).find('.select__name').text($(this).find('.select__option').first().text());
            $('.select__wrap').find('textarea').val('');
        });
        nullObj();
        
    }

    function nullObj(){
        obj.optional = '';
        obj.texture = '';
        obj.design = '';
        obj.ashes = '';
        obj.other = '';
        obj.engraved = '';
        obj.engraved_item = false;
    }
    function clearDisplayBox(){
       // $('.display_box').addClass('hidden');
        $('.my-product-form__submit').addClass('disable');
        $('.display_box-contant input').val('');
        $('.display_box-contant .input_wrap').removeClass('active');
    }
    function allElementHide(){
        $('.select__wrap').addClass('hidden');
        clearDisplayBox();
        $('.inclusion__checkboxs .select__wrap').removeClass('hidden');  
    }

    function elementShowOptional(el1=0, el2=0,el3=0){
      
        console.log(arguments.length);
        if(el1 !='' && arguments.length == 1){
            console.log('zashel1');
            someShowItems(['.select__wrap[data-item="optional"]']);  
        }else if(el1 != '' && el2 != '' && arguments.length == 2){
            console.log('zashel2');
            someShowItems(['.select__wrap[data-item="optional"]']);  
        }else if(el1 != '' && el2 != '' && el3 != '' && arguments.length == 3){
          console.log('zashel3');
            someShowItems(['.select__wrap[data-item="optional"]']);  
        }else{
            console.log('zashel4');
            obj.optional = '';
            $('.select__wrap[data-item="optional"] input').each(function(){
                    $(this).prop('checked', false);
            });
            $('.select__wrap[data-item="optional"] .select-item-name').find('h6').text('free add on (Optional)');
            $('.select__wrap[data-item="optional"]').addClass('hidden');
            $('.select__wrap[data-item="optional"]').removeClass('active');
        }
        console.log(obj);
    }

    function someShowItems(arr){
        arr.forEach(el => {
            $(el).removeClass('hidden')
        });
    }
    function unDisableCustomSelectCheckbox(){
      $('.inclusion__checkboxs .check-select-items .check-item').each(function(){
          
            $(this).find('input').prop( 'disabled', false );
          
      });
    }
    function disableCustomSelectCheckbox(){
      $('.inclusion__checkboxs .check-select-items .check-item').each(function(){
          if( !$(this).find('input').is(':checked')){
            $(this).find('input').prop( 'disabled', true );
          }
      });
    }
    function changeVariantInclusion(l){
      console.log('length:', l);
      
      if( l == 2){
          $('.select-inclusion').val('two inclusions');
          //unDisableCustomSelectCheckbox();
        disableCustomSelectCheckbox();
      }else if(l == 3){
          $('.select-inclusion').val('three inclusions');
          disableCustomSelectCheckbox();
          
      }else{
          $('.select-inclusion').val('one inclusion');
          unDisableCustomSelectCheckbox();
      }

      //$('variant-selects')[0].onVariantChange();
      addInclusionPrice();
      
    }



  
    function elementSearch(arr){
        let bol = arr.length > 0 ? true : false;
        
        console.log(bol);
        
        if(bol){
            console.log("true");
            if(arr.includes('breastmilk') &&  !arr.includes('ashes') && !arr.includes('other')){
                allElementHide();
                someShowItems(['.select__wrap[data-item="texture"]']);
                elementShowOptional(obj.texture);
        
            }else if( !arr.includes('breastmilk') &&  arr.includes('ashes') && !arr.includes('other')){
                allElementHide();
                someShowItems(['.select__wrap[data-item="ashes"]']);
                elementShowOptional(obj.ashes);
            }else if( !arr.includes('breastmilk') &&  !arr.includes('ashes') && arr.includes('other')){
                allElementHide();
                someShowItems(['.select__wrap[data-item="other"]']);
                elementShowOptional(obj.other);
            }else if( arr.includes('breastmilk') &&  arr.includes('ashes') && !arr.includes('other')){
                allElementHide();
                someShowItems(['.select__wrap[data-item="texture"]','.select__wrap[data-item="ashes"]']);
                elementShowOptional(obj.ashes ,obj.texture); 
            }else if( arr.includes('breastmilk')  && arr.includes('other') &&  !arr.includes('ashes')){
                allElementHide();
                someShowItems(['.select__wrap[data-item="texture"]','.select__wrap[data-item="other"]']);    
                elementShowOptional(obj.texture ,obj.other);  
                
            }else if( arr.includes('ashes') && arr.includes('other') && !arr.includes('breastmilk')){
                allElementHide();
                someShowItems(['.select__wrap[data-item="ashes"]','.select__wrap[data-item="other"]']);   
                elementShowOptional(obj.ashes, obj.other);   
            }else if( arr.includes('breastmilk') &&  arr.includes('ashes') && arr.includes('other')){
                allElementHide();
                someShowItems(['.select__wrap[data-item="ashes"]','.select__wrap[data-item="other"]','.select__wrap[data-item="texture"]']);  
                elementShowOptional(obj.ashes , obj.other ,obj.texture);  
            }else{
                obj.optional = '';
                $('.select__wrap[data-item="optional"] input').each(function(){
                    $(this).prop('checked', false);
                });
                $('.select__wrap[data-item="optional"] .select-item-name').find('h6').text('free add on (Optional)');
                allElementHide();
                someShowItems(['.select__wrap[data-item="optional"]']);  
            }
        }else{
            allElementHide();
            obj.inclusions = '';
            nullObj();
            return
        }
        
        console.log(obj);
            
    }

    $(document).mouseup( function(e){ 
      $('.custom__select').each(function(){
        let div = $(this); 
        if ( !div.is(e.target) && div.has(e.target).length === 0 ) { 
            div.removeClass('active'); 
        }
      });
       
    });

    $('.inclusion__name').click(function(){
        $(this).closest('.inclusion__variant').toggleClass('active');
    });

    $('.inclusion__checkboxs .select__wrap').click(function(){
        $('.select-checkbox').toggleClass('active');
    });
    
    $('.inclusion__checkboxs .check-item input').change(function(){
        arr = [];
        nullElement();
        $('.inclusion__checkboxs .check-item').each(function(){
            if($(this).find('input').is(':checked')){
                arr.push($(this).find('input').val().toLowerCase());
            }
        });
        changeVariantInclusion(arr.length);
        if(arr.length > 0){
            let str = arr.join(',');
            $('.inclusion__checkboxs .select-item-name h6').text(str);
            $(this).closest('.inclusion__checkboxs .select__wrap').addClass('active');
            obj.inclusions = str;
           
        }else{
            $('.inclusion__checkboxs .select-item-name h6').text('Choose your Inclusions');
            $(this).closest('.select__wrap').removeClass('active');
            obj.inclusions = '';
        }
        elementSearch(arr);
    });

  $('[data-inclusions] .inclusion__checkboxs .check-item input').change(function(){
      $('.inclusions .select__wrap').css('border','1px solid #FFFFFF');
      $('.inclusions .select__wrap.active').css('border','1px solid #CFA96A');     
  });
  
    $('.select__name').click(function(){
        $(this).closest('.custom__select').toggleClass('active');
    });

    $('.custom__select .select__option').click(function(){
        let v = $(this).attr('value');
        if(v != ''){
            $(this).closest('.select__wrap').addClass('active');
            $(this).closest('.custom__select').find('.select__name').text(v);
        }else{
            $(this).closest('.select__wrap').removeClass('active');
            $(this).closest('.custom__select').find('.select__name').text($(this).text());
        }
     // elementSearch(arr);
    });

    $('.select__wrap[data-item="texture"] .select__option').click(function(){
        obj.texture = $(this).attr('value');
        elementSearch(arr);
    });

    $('.select__wrap[data-item="ashes"] .select__option').click(function(){
        obj.ashes = $(this).attr('value');
        elementSearch(arr);
    });
    console.log(27);
    function showEngreved(){
      someShowItems(['.select__wrap[data-item="engraved"]']);
      /*let vl = $('.select [name="options[Metal]"], .select [name="options[Charm Metal]"]').val().toLowerCase();
        if(vl == '14k solid rose gold' || vl == '14k solid yellow gold' || vl == '14k solid white gold'){
          console.log('zashel');
          someShowItems(['.select__wrap[data-item="engraved"]']);
        }else{
          $('.select__wrap[data-item="engraved"]').addClass('hidden');
          obj.engraved='';
          $('.display_box').removeClass('hidden');
         
        }*/
      
     
    }

    $(document).on('change','.select [name="options[Metal]"], .select [name="options[Length]"], .select [name="options[Charm Metal]"]', ()=>{
      $('.inclusion__checkboxs .check-item').find('input').prop('checked',false);
      $('.inclusion__checkboxs .select-item-name h6').text('Choose your Inclusions');
       arr = [];
       nullElement();
       elementSearch(arr);
    });
  $('.select__wrap[data-item="optional"] .select-item-name').click(function(){
      $('.select__wrap[data-item="optional"] .select-checkbox').toggleClass('active');
  });

   $('.select__wrap[data-item="optional"] .check-item input').change(function(){
       let arrOptional = [];

      if($(this).hasClass('no-add')){
        $('.select__wrap[data-item="optional"] input:not(.no-add)').each(function(){
                    $(this).prop('checked', false);
        });
      }else{
        $('.select__wrap[data-item="optional"] input.no-add').prop('checked', false);
      }

     
       $('.select__wrap[data-item="optional"] .check-item').each(function(){
           if($(this).find('input').is(':checked')){
                arrOptional.push($(this).find('input').val());
           }
       }); 
       console.log(arrOptional.length);
       if( arrOptional.length != 0){
           let str =  arrOptional.join(',');
           obj.optional = str;
           $('.select__wrap[data-item="optional"] .select-item-name h6').text(str.toUpperCase());
           $('.select__wrap[data-item="optional"]').addClass('active');
           someShowItems(['.select__wrap[data-item="design"]']);
           showEngreved();
       }else if (arr.length > 1 ){
            someShowItems(['.select__wrap[data-item="design"]']);
        }else{
           obj.optional = '';
           $('.select__wrap[data-item="optional"] input').each(function(){
                    $(this).prop('checked', false);
            });
           $('.select__wrap[data-item="optional"] .select-item-name').find('h6').text('free add on (Optional)');
           $('.select__wrap[data-item="optional"]').removeClass('active');
           $('.select__wrap[data-item="design"]').addClass('hidden');
           obj.design = '';
           $('.select__wrap[data-item="design"]').removeClass('active');
           $('.select__wrap[data-item="design"] .select__name').text($('.select__wrap[data-item="design"] .select__option').first().text());
       }
   });

    $('.select__wrap[data-item="design"] .select__option').click(function(){
        obj.design = $(this).attr('value');
        showEngreved();
    });
    function addEngrevedPrice(){
      let engPrice = +$('.select-inclusion option:selected').attr('data-price').replace(/[^+\d]/g, '');
      let priceVariant = +$('.price-item.price-item--regular').attr('data-price').replace(/[^+\d]/g, '');
      console.log(engPrice,priceVariant);
      let newPrice = engPrice + priceVariant;
      $('.price-item--regular').text('$' + newPrice);
    }
    function addInclusionPrice(){
       let priceVariant = +$('.price-item.price-item--regular').attr('data-price').replace(/[^+\d]/g, '');
       let incPrice = +$('.select-inclusion option:selected').attr('data-price').replace(/[^+\d]/g, '');
       console.log(priceVariant,  incPrice);
       let newPrice1 = incPrice + priceVariant;
       console.log(newPrice1);
       $('.price-item--regular').text('$'+ newPrice1);
    }

  
    $('.select__wrap[data-item="engraved"] .select__option').click(function(){
        let vE = $(this).attr('value');
        if(vE != '' && vE != 'no' || vE == 'yes'){
            obj.engraved_item = true;
           clearDisplayBox();
           someShowItems(['.select__wrap[data-item="engraved_text"]']);
           addEngrevedPrice();
        }else{
          obj.engraved_item = false;
          $('.select__wrap[data-item="engraved_text"]').addClass('hidden');
          $('.display_box').removeClass('hidden');
          $('variant-selects')[0].onVariantChange();
        }
        
    });
    $('.select__wrap[data-item="other"] .textarea-btn').click(function(e){
        e.preventDefault();
        obj.other = $(this).closest('.select__wrap').find('textarea').val();
        if( obj.other != ''){
            $(this).closest('.select__wrap').addClass('active');
        }else{
            $(this).closest('.select__wrap').removeClass('active');
        }
        elementSearch(arr);
    });
     $('.select__wrap[data-item="engraved_text"] .textarea-btn').click(function(e){
        e.preventDefault();
        obj.engraved = $(this).closest('.select__wrap').find('textarea').val();
        if( obj.engraved != ''){
            $('.display_box').removeClass('hidden');
           
            $(this).closest('.select__wrap').addClass('active');
        }else{
            clearDisplayBox();
            $(this).closest('.select__wrap').removeClass('active');
        }
    });
   function indexGeneral(){
        let arr_nun = [0 ,1,2,3,4,5,6,7,8,9];
        let arr_en = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
        let arr_EN = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
        let mass = [...arr_en, ...arr_EN,...arr_nun];
        console.log(mass);
        let index = [];
        for(let i = 0; i <= 6; i++){
            let el = mass[Math.floor(Math.random() * mass.length)];
            index.push(el);
        }
        
       return index.join('');
     
   }

  $('.display_box-contant input').on('input', function(){
    if($(this).val() != ''){
      $(this).closest('.input_wrap').addClass('active');
    }else{
      $(this).closest('.input_wrap').removeClass('active');
    }
  });

  $('.req_input').on('input', function(){
    let fild_count = 0;
    console.log(1);
    $('.req_input').each(function(){
        if($(this).val() != ''){
          fild_count++;
          $(this).closest('.input_wrap').css('border','1px solid #FFFFFF');
        }
    });
     console.log(fild_count, $('.req_input').length);
    if(fild_count == $('.req_input').length){
       $('.my-product-form__submit').removeClass('disable');
    }else{
       $('.my-product-form__submit').addClass('disable');
    }

   // validLineItem();
    
  });

  
 function handleResponse() {
              let a = this.responseText;
              let parser = new DOMParser();
              let objCarts = JSON.parse(this.responseText);
              $('#cart-icon-bubble').html($(objCarts["cart-icon-bubble"]).html());
              $('cart-drawer').html($(objCarts["cart-drawer"]).find('cart-drawer').html());
            }
           
    
function addCustomProperties(obj){
  $('.my-custom-property').each(function(){
    if($(this).val() != ''){
      objName = $(this).attr('prop-name');
      obj[objName] = $(this).val();
    }
  });
}
let valid;
function validLineItem(){
  let fild_count = 0;
  valid=false;
    //console.log(1);
    $('.req_input').each(function(){
        if($(this).val() != ''){
          fild_count++;
          $(this).closest('.input_wrap').css('border','1px solid #FFFFFF');
        }else{
          $(this).closest('.input_wrap').css('border','1px solid #B53E2E');
        }
    });
     /*console.log(fild_count, $('.req_input').length);
    if(fild_count == $('.req_input').length){
      $('.my-product-form__submit').removeClass('disable');
       valid=true;
    }else{
      $('.my-product-form__submit').addClass('disable');
      $('.inclusions[data-inclusions] .inclusion__body').addClass('active');
      valid=false;
    }*/
    if(obj.optional != '' || obj.engraved != ''){
      console.log(7);
      if(fild_count == $('.req_input').length){
      $('.my-product-form__submit').removeClass('disable');
       valid=true;
      }else{
        $('.my-product-form__submit').addClass('disable');
        $('.inclusions[data-inclusions] .inclusion__body').addClass('active');
        valid=false;
      }
    }else{
        console.log(8);
        $('.inclusions .select__wrap:not(.active)').css('border','1px solid #B53E2E');
        $('.inclusions[data-inclusions] .inclusion__body').addClass('active');
        //$('.inclusions.display_box .inclusion__body').addClass('active');
        $('.inclusions.display_box .inclusion__body').removeClass('active');
        $('.my-product-form__submit-max').addClass('disable');
        valid=false;
    }
}


  
$('.product .my-product-form__submit').click(function(e){
       e.preventDefault();
       validLineItem();
       let inclusionId = $('.inclusion-variant').val();
     //  $('.product .my-product-form__submit').removeClass('loading');
       
       let idProduct = indexGeneral();
       let formData = {}  
       let properties = {
          'Size':$('.propert-size').find('input').val(),
          'Created for':$('#your-create').val(),
          'In Honor of':$('#your-honor').val(),
          'id-product': idProduct,
          'Inclusions':obj.inclusions,
          'Ashes': obj.ashes,
          'Other' : obj.other,
          'Texture' : obj.texture,
          'Optional': obj.optional,
          'Design':obj.design,
          'Engraved': obj.engraved
       };
       addCustomProperties(properties);
       
  
       if(obj.engraved_item ){
          
          formData = {
             items: [
                 {
                      id:$('.select-inclusion option:selected').attr('data-id'),
                      quantity: $('.quantity__input').val(),
                       properties: {
                        'id-product': 'inclusion-' + idProduct,
                       }
                  },
                  {
                      id:$('.inclusion-variant').val(),
                      quantity: $('.quantity__input').val(),
                      properties: {
                        'id-product': 'engraved-' + idProduct,
                      }
                  },
                  {
                    id:$('.product-variant-id').val(),
                    quantity: $('.quantity__input').val(),
                   properties:  properties 
                  }
                  
                  
                  
            ]
          };
       }else{
            formData = {
               items: [
                    {
                      id:$('.select-inclusion option:selected').attr('data-id'),
                      quantity: $('.quantity__input').val(),
                       properties: {
                        'id-product': 'inclusion-' + idProduct,
                       }
                    },
                    {
                      id:$('.product-variant-id').val(),
                      quantity: $('.quantity__input').val(),
                      properties: properties
                    }, 
                     
                    
                    
                    
                    
              ]
            };
       }
      
       
      if(valid){
        $(this).addClass('loading');
        $(this).find('.loading-overlay__spinner').removeClass('hidden');
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {

            const request = new XMLHttpRequest();
            request.addEventListener('load', handleResponse);
            request.open('GET', '?sections=cart-drawer,main-cart-items,cart-icon-bubble', true);///?sections=cart-drawer,
            request.send();
            $('cart-drawer')[0].open();
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        })
        .finally(function(){
            $('cart-drawer').removeClass('is-empty');
            $('.product .my-product-form__submit').removeClass('loading');
            $('.product .my-product-form__submit').find('.loading-overlay__spinner').addClass('hidden');
          
        });
      }
        
  });



  $(document).on('click','#CartDrawer-Overlay',function(){
      
      $('cart-drawer')[0].close();
  });
});